import {
    styled,
    TextField
} from "@mui/material";

export const CssTextField = styled(TextField)({
    '& .MuiInputBase-root': {
        color: '#1e293b',
        fontWeight: '500',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        transition: 'all 0.2s ease',
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '16px',
        '& fieldset': {
            borderColor: '#e2e8f0',
            borderRadius: '16px',
            transition: 'all 0.2s ease',
        },
        '&:hover fieldset': {
            borderColor: '#cbd5e1',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#112a56',
            borderWidth: '1.5px',
        },
        '&.Mui-focused': {
            boxShadow: '0 2px 10px rgba(17, 42, 86, 0.08)',
        }
    },
    '& .MuiInputBase-input::placeholder': {
        color: '#94a3b8',
        opacity: 1,
    }
});